import ko from "knockout";
import register from "flow/knockout/register";

register.registerKnockoutBinding("menuClick", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const newValueAccessor = function () {
            return function () {
                if (bindingContext.$data.isLocked && bindingContext.$data.isLocked() == true) {
                    return;
                }

                if (valueAccessor().closeMenu !== undefined) {
                    if (valueAccessor().closeMenu == true) {
                        bindingContext.$root.mobileMenuExpanded(false);
                    }

                    valueAccessor().action(bindingContext.$data);
                } else {
                    bindingContext.$root.mobileMenuExpanded(false);
                    valueAccessor()(bindingContext.$data);
                }
            };
        };

        return ko.bindingHandlers.click.init(element, newValueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
});

(ko.punches as any).wrappedCallback.enableForBinding("menuClick");
